import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from "@angular/common";

@Pipe({
  name: 'todayDateSelected'
})
export class TodayDateSelectedPipe implements PipeTransform {

  today = new Date().getFullYear() + '-'+ ('0' + (new Date().getMonth()+1)).slice(-2)  + '-' + ('0' + new Date().getDate()).slice(-2)

  transform(selectedDate: string): boolean {


    if (selectedDate === this.today) {
      return true
    } else { return false }
  }

}
